import * as t from 'io-ts'

import { TaskStatesIO, TaskStateT } from '.'

export const TaskEventKeys = {
  CREATE: 'Create',
  INBOX: 'Inbox',
  PENDING: 'Pending',
  IN_PROGRESS: 'In Progress',
  SKIP_EDITING: 'Skip Editing',
  RESTART_EDITING: 'Restart Editing',
  APPROVED: 'Finish Editing',
  START_PUBLICATION: 'Start Publication',
  ABORT_PUBLICATION: 'Abort Publication',
  FINISH_PUBLICATION: 'Finish Publication',
  NO_EDITING_REQUIRED: 'No Editing Required',
  BLOCK: 'BLOCK',
  REJECTED_BY_PUBLISHER: 'Rejected by Publisher',
  REJECTED_BY_PUBLISHER_TO_EDITOR: 'Rejected by Publisher to editor',
  RECONCILE_NO_CHANGES: 'Reconcile No Changes',
  ESCALATE: 'Escalate',
  ESCALATE_DETACH: 'Escalate Detach',
  UNBLOCK: 'Unblock',
  PAUSE: 'Paus',
  UNPAUSE: 'Unpaus',
  REASSIGN: 'Reassign',
  UNASSIGN: 'Unassign',
  UNASSIGN_EDITOR: 'Unassign Editor',
  ARCHIVE: 'Archive',
  SET_STATE: 'Set State',
  CLOSE: 'Close',
  DETACH: 'Detach',
}
export const TaskEventKeyIO = t.keyof(TaskEventKeys)
export type TaskEventKeyT = t.TypeOf<typeof TaskEventKeyIO>

export const TaskEventCountIO = t.intersection([
  t.type({
    id: t.string,
    date: t.number,
    username: t.string,
    previous_state: TaskStatesIO,
    current_state: TaskStatesIO,
    event_type: TaskEventKeyIO,
    count: t.number,
    task_ids: t.array(t.string),
  }),
  t.partial({
    sub_type: t.string,
  }),
])
export type TaskEventCountT = t.TypeOf<typeof TaskEventCountIO>
